import React from "react";
import { Workflow, BCMSDate, BCMSRecord, useBCMSContext, useParams, useModel } from "@bcm-dev/bcms-vite";
import LoginPage from "components/pages/LoginPage";


const steps = [<LoginPage/> ];

/**
 * @function LoginWorkflow
 * @returns {React.Component}
 * @description The main component for the dispute transaction workflow.
 * @exported true
 * @example <DisputeTransactionWorkflow />
 */
export default function LoginWorkflow(props) {
    const globalController = useBCMSContext();
 
   
    const value = getDefaultPageData(globalController );
    return <Workflow value={ value } steps={ steps } />;
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultPageData
 * @returns {OBJECT}
 * @exported true
 * @description Returns the default values for the dispute transaction
 */
export const getDefaultPageData = (controller ) => {
   
 

    return {
        userName: undefined,
        password: undefined,
        showPassword: false,
        rememberUserName:true,
      
      
    }
};